var map = {
	"./abstract_1.svg": [
		3685,
		685
	],
	"./abstract_2.svg": [
		57642,
		642
	],
	"./abstract_3.svg": [
		88812,
		812
	],
	"./abstract_4.svg": [
		14570,
		570
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83146;
module.exports = webpackAsyncContext;